import { useNavigate } from 'react-router-dom';
import { Box, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { RefreshRounded } from '@mui/icons-material';

import { Add, Edit } from '@brainpool/icon-pack';
import Button from '@brainpool/components/atoms/Button/Button';
import { goToPage } from '../../../utils/commonFunctions';

export interface ButtonStackProps {
  onRefresh: () => void;
  onCustomise: () => void;
}

export function ButtonStack({ onRefresh, onCustomise }: ButtonStackProps) {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Stack direction="row" justifyContent="flex-end">
      <Button variant="text" onClick={onRefresh} data-testid="refresh-button">
        <Tooltip title="Refresh table">
          <RefreshRounded fontSize="medium" sx={{ fontSize: 16, color: 'info.dark' }} />
        </Tooltip>
      </Button>
      <Button variant="contained" color="info" onClick={onCustomise}>
        <Typography sx={{ marginRight: 1 }} color="success.dark">
          Customise
        </Typography>
        <Edit size={16} fill={theme.palette.success.dark} />
      </Button>

      <Box>
        <Button variant="contained" onClick={() => goToPage('/new-project', navigate)}>
          <Typography sx={{ marginRight: 1 }}>Add Project</Typography>
          <Add size={16} fill={theme.palette.text.primary} />
        </Button>
      </Box>
    </Stack>
  );
}
export default ButtonStack;
